import React, { useContext } from 'react';
import QRCode from 'react-qr-code';

import { AppContext } from '../../App';

import { useTheme } from 'styled-components';

import {
  _FullPageContainer as FullPageContainer,
  _Title as Title,
} from './QRcode.style';

const QRcode = () => {
  const { channel, formAttributes, urlParams } = useContext(AppContext);
  const { UID } = formAttributes;

  let webUrl = '';
  let logoSrc = '';
  switch (channel) {
    case '1':
      webUrl = process.env.REACT_APP_WEB_URL_CHANNEL_1;
      logoSrc =
        'https://generic-v2.c.skbv.se/store/layout/logo/sv/skbv_logo_bm_large.png';
      break;
    case '4':
      webUrl = process.env.REACT_APP_WEB_URL_CHANNEL_4;
      logoSrc =
        'https://generic-v2.c.skbv.se/store/layout/logo/no/gf_logo_bm_large.png';
      break;
    case '7':
      webUrl = process.env.REACT_APP_WEB_URL_CHANNEL_7;
      logoSrc =
        'https://generic-v2.c.skbv.se/store/layout/logo/fi/nr_logo_bm_se_large.png';
      break;
    case '8':
      webUrl = process.env.REACT_APP_WEB_URL_CHANNEL_8;
      logoSrc =
        'https://generic-v2.c.skbv.se/store/layout/logo/fi/nr_logo_bm_fi_large.png';
      break;
    default:
      console.log('Invalid channel id');
  }

  const params = Object.entries(urlParams)
    .filter((value) => value[0] !== 'qr')
    .map((value) => `${value[0]}=${value[1]}`);

  const addParams = params.join('&');
  const formUrl = `${webUrl}/${UID}${addParams ? '?' + addParams : ''}`;

  const theme = useTheme();
  return (
    <FullPageContainer>
      <QRCode
        size={256}
        value={formUrl}
        style={{ maxWidth: '90%' }}
        viewBox={`0 0 256 256`}
        fgColor={theme.primary}
      />
      <Title>{formAttributes.name}</Title>
      <img src={logoSrc} alt='logo' width='200px' height='67px' />
    </FullPageContainer>
  );
};

export default QRcode;
